import { isRepoAdmin } from "./permissions";

/** Case fields hidden from team leaders, office staff, repo staff, and viewers. */
export const ADMIN_ONLY_CASE_KEYS = new Set([
  "loanAccountNumber",
  "bankName",
  "branchName",
  "mobileNumber",
  "alternateMobileNumber",
  "referenceNumber",
  "caseCode",
  "vehicleType",
  "dueAmount",
  "totalOutstandingAmount",
  "emiAmount",
  "bucket",
  "address",
  "banker1Name",
  "banker1Phone",
  "banker2Name",
  "banker2Phone",
  "banker3Name",
  "banker3Phone",
]);

export const ADMIN_ONLY_CASE_LABELS = new Set([
  "Loan Account Number",
  "Loan Account No",
  "Loan Account",
  "Bank Name",
  "Branch Name",
  "Bank",
  "Branch",
  "Bank / Branch",
  "Finance",
  "Branch (xlsx)",
  "Agreement No",
  "Mobile Number",
  "Mobile",
  "Alternate Mobile",
  "Reference Number",
  "Case Code",
  "Vehicle Type",
  "Due Amount",
  "Outstanding",
  "EMI Amount",
  "EMI",
  "Bucket",
  "Address",
  "Full Address",
  "1st bankar Name",
  "2nd bankar Name",
  "3rd bankar Name",
  "1st banker Name",
  "2nd banker Name",
  "3rd banker Name",
  "mobile no 1",
  "mobile no 2",
  "mobile no 3",
]);

export function shouldShowAdminOnlyCaseFields(role) {
  return isRepoAdmin(role);
}

export function isAdminOnlyCaseKey(key) {
  return ADMIN_ONLY_CASE_KEYS.has(key);
}

export function isAdminOnlyCaseLabel(label) {
  return ADMIN_ONLY_CASE_LABELS.has(label);
}

export function filterFieldsByRole(fields, role, { keyField = "key", labelField = "label" } = {}) {
  if (shouldShowAdminOnlyCaseFields(role)) return fields;
  return fields.filter((field) => {
    if (field[keyField] && isAdminOnlyCaseKey(field[keyField])) return false;
    if (field[labelField] && isAdminOnlyCaseLabel(field[labelField])) return false;
    return true;
  });
}

export function filterCaseFieldRows(rows, role) {
  if (shouldShowAdminOnlyCaseFields(role)) return rows;
  return rows.filter((row) => !isAdminOnlyCaseLabel(row.label));
}
